import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombOfNefertitiBackground} from "../../background/TombOfNefertitiBackground";
import {TombOfNefertitiReelStopPresentationController} from "../../reelStopPresentation/TombOfNefertitiReelStopPresentationController";
import {TombOfNefertitiFreeSpinIntroView} from "../../screen/freespinintro/TombOfNefertitiFreeSpinIntroView";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertitiScatterAttentionView} from "./TombOfNefertitiScatterAttentionView";

export class TombOfNefertitiScatterAttentionController extends BaseController {
    private _view:TombOfNefertitiScatterAttentionView;
    private _cleanupRequired:boolean = false;

    constructor() {
        super();
        this._view = new TombOfNefertitiScatterAttentionView();

        EventHandler.addEventListener(this, TombOfNefertitiReelStopPresentationController.ADD_SCATTER_ATTENTION, (event:GameEvent) => this.addAttention(event.params[0]));
        EventHandler.addEventListener(this, TombOfNefertitiReelStopPresentationController.CLEAR_ATTENTION_FROM_REEL, (event:GameEvent) => this.clearAttention(event.params[0]));
        EventHandler.addEventListener(this, TombOfNefertitiReelStopPresentationController.CLEAR_LANDING_ANIMATION_FROM_REEL, () => this.stopAllReelLandingAnimation());
        EventHandler.addEventListener(this, TombOfNefertitiReelStopPresentationController.ADD_SCATTER_LANDING_ANIMATION, (event:GameEvent) => this.addScatterLandingAnimation(event.params[0]));
        EventHandler.addEventListener(this, TombOfNefertitiFreeSpinIntroView.PLAY_SCATTER_ANIMATION, () => this._view.playScatterAnimation());
    }

    private addScatterLandingAnimation(reelId:number):void {
        this._view.addLandingAnimationToReel(reelId);
    }

    private addAttention(indexArr:number[]):void {
        if(this._cleanupRequired) {
            return;
        }
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiBackground.TENSE_BG_FOR_ATTENTION));
        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.ANTICIPATION);
        this._view.updateAnticipatingPositions(indexArr);
        this._view.addAttentionToReels(indexArr);
        this._cleanupRequired = true;
    }

    private clearAttention(reelId:number):void {
        if(reelId !== -1) {
            this._view.stopReelAttention(reelId);
        } else {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiBackground.CLEAR_TENSE_BG_FOR_ATTENTION));
            this._view.stopAllReelAttention();
            SlotGame.sound.stopEffect(TombOfNefertitiSoundConfig.instance.ANTICIPATION);
            this._cleanupRequired = false;
        }
    }

    private stopAllReelLandingAnimation():void {
        if(this._view.scatterCount === 2) {
            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.ANTICIPATION_FAIL);
        }

        this._view.stopAllReelLandingAnimation();
    }
}